export default __webpack_public_path__ + "static/media/add.5c3cd078.png";